import * as $ from 'jquery';
import { BaseEngine } from './baseEngine.js';

export class CodingMat extends BaseEngine {
  _widthItem;
  _heightItem;
  _rows;
  _cols;
  _colorBgrTarget;

  constructor() {
    super({ engine: 'dnd' });
    console.log(this);
    this._widthItem = 100;
    this._heightItem = 100;
    this._rows = 1;
    this._cols = 1;
    this._colorBgrTarget = '#ffffff';
    this._removeInCorrects = true;

    this.layout.groups.push(
      {
        idGroup: 'target',
        itemsConfig: {
          background: {
            color: 'rgb(0,0,0)',
          },
        },
        otherProperty: {
          hooks: {
            background: {
              color: this._colorBgrTarget,
            },
            positions: {
              columns: this._cols,
              rows: this._rows,
              pos: { width: this._widthItem, height: this._heightItem },
              margin: { left: 1, right: 1, top: 1, bottom: 1 },
            },
            items: [{ id: 'h1' }],
          },
        },
        items: [{ id: 'mat' }],
      },
      {
        idGroup: 'source',
        itemsConfig: {
          background: {
            border: { color: 'black', size: 2 },
            color: 'rgb(255, 255, 255)',
          },
          positions: {
            rows: this._rows,
            pos: { width: this._widthItem, height: this._heightItem },
            margin: { left: 1, right: 1, top: 1, bottom: 1 },
          },
        },
        otherProperty: { clones: { cloneNumber: this._rows * this._cols - 1, underOriginal: true } },
        items: [{ id: 's1', background: { color: 'rgb(255, 255, 255)' } }],
      }
    );

    if (this.withoutCheck === true) {
      this.rulesGame.itemsGarbage = [
        { idGroup: 'target', itemsConfig: { block: true } },
        { idGroup: 'source', itemsConfig: { block: false } },
      ];
      this.rulesGame.itemsConfig = { block: true };
      this.rulesGame.items = [{ idGroup: 'target', idItem: 'mat' }];
    }
  }

  addColorSource(id) {
    this.layout.groups[1].items.push({ id: id, background: { color: 'rgb(255, 255, 255)' } });
  }

  changeColorSource(item) {
    for (let i in this.layout.groups[1].items) {
      if ($(item).attr('id') != this.layout.groups[1].items[i].id) {
        continue;
      }
      this.layout.groups[1].items[i].background.color = $(item).val();
    }
  }

  removeColorSource(id) {
    let key = -1;
    for (let i in this.layout.groups[1].items) {
      if (id == this.layout.groups[1].items[i].id) {
        key = i;
        break;
      }
    }
    if (key > -1) {
      this.layout.groups[1].items.splice(key, 1);
    } else {
      console.log('NIE MA TAKIEGO ELEMENTU W TABLICY SOURCE, ID: ' + id);
    }
  }

  set widthItem(val) {
    this._widthItem = parseInt(val);
    this.layout.groups[0].otherProperty.hooks.positions.pos.width = this._widthItem;
    this.layout.groups[1].itemsConfig.positions.pos.width = this._widthItem;
  }
  get widthItem() {
    return this._widthItem;
  }

  set heightItem(val) {
    this._heightItem = parseInt(val);
    this.layout.groups[0].otherProperty.hooks.positions.pos.height = this._heightItem;
    this.layout.groups[1].itemsConfig.positions.pos.height = this._heightItem;
  }
  get heightItem() {
    return this._heightItem;
  }

  set cols(val) {
    this._cols = parseInt(val);
    this.layout.groups[0].otherProperty.hooks.positions.columns = this._cols;
    this.layout.groups[0].otherProperty.hooks.items.splice(0, this.layout.groups[0].otherProperty.hooks.items.length);
    for (let i = 1; i <= this._cols * this._rows; i++) {
      this.layout.groups[0].otherProperty.hooks.items.push({ id: 'h' + i });
    }
    this.layout.groups[1].otherProperty.clones.cloneNumber = this._cols * this._rows - 1;
  }
  get cols() {
    return this._cols;
  }

  set rows(val) {
    this._rows = parseInt(val);
    this.layout.groups[0].otherProperty.hooks.positions.rows = this._rows;
    this.layout.groups[0].otherProperty.hooks.items.splice(0, this.layout.groups[0].otherProperty.hooks.items.length);
    this.layout.groups[1].itemsConfig.positions.rows = this._rows;
    for (let i = 1; i <= this._cols * this._rows; i++) {
      this.layout.groups[0].otherProperty.hooks.items.push({ id: 'h' + i });
    }
    this.layout.groups[1].otherProperty.clones.cloneNumber = this._cols * this._rows - 1;
  }
  get rows() {
    return this._rows;
  }

  set colorBgrTarget(val) {
    this.layout.groups[0].otherProperty.hooks.background.color = val;
    this._colorBgrTarget = val;
  }

  get colorBgrTarget() {
    return this._colorBgrTarget;
  }
}
